export default {
  'pages.layouts.userLayout.title': 'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.serviceOverview.p1': '科沃斯核心API现已全面兼容MCP协议，是全球首家兼容MCP协议的机器人服务商。',
  'pages.serviceOverview.p2': '科沃斯已经完成了4个核心API接口和MCP协议的对接，包括设备列表查询、清扫控制、回充控制和工作状态查询。',
  'pages.serviceOverview.p3': '作为全球首家支持MCP协议的清洁机器人服务商，科沃斯MCP Server发布后，智能体开发者仅需简单配置，就可以在大模型中快速接入机器人服务，实现查询、清扫、回充等能力。',
  'pages.serviceOverview.p4': '大幅降低了智能体应用开发过程中调用机器人控制服务相关能力的门槛，显著提升了智能体应用的开发效率。',
  'pages.serviceOverview.featureIntroduction': '功能介绍',
  'pages.serviceOverview.deviceListQuery': '设备列表查询',
  'pages.serviceOverview.deviceListQuery.p1': '获取用户绑定的所有机器人列表。',
  'pages.noParameters': '无参数',
  'pages.serviceOverview.statusDescription': 'status为0表示成功，-1表示失败',
  'pages.serviceOverview.cleaningControl': '清扫控制',
  'pages.serviceOverview.cleaningControl.p1': '启动扫地机器人开始清扫。',
  'pages.serviceOverview.cleaningControl.p2': '机器人的昵称，用于查找设备，支持模糊匹配',
  'pages.serviceOverview.cleaningControl.p3': '清扫行为',
  'pages.serviceOverview.cleaningControl.p4': '开始清扫'  ,
  'pages.serviceOverview.cleaningControl.p5': '恢复清扫',
  'pages.serviceOverview.cleaningControl.p6': '暂停清扫',
  'pages.serviceOverview.cleaningControl.p7': '停止清扫',
  'pages.serviceOverview.rechargeControl': '控制回充',
  'pages.serviceOverview.rechargeControl.p1': '控制扫地机器人回充或结束回充。',
  'pages.serviceOverview.rechargeControl.p2': '机器人的昵称，用于查找设备',
  'pages.serviceOverview.rechargeControl.p3': '机器行为',
  'pages.serviceOverview.rechargeControl.p4': '开始回充',
  'pages.serviceOverview.rechargeControl.p5': '结束回充',
  'pages.serviceOverview.workStateQuery': '工作状态查询',
  'pages.serviceOverview.workStateQuery.p1': '获取扫地机器人当前的工作状态。',
  'pages.serviceOverview.workStateQuery.p2': '机器人的昵称，用于查找设备',
  'pages.parameterName': '参数名',
  'pages.parameterType': '类型',
  'pages.parameterDescription': '说明',
  'pages.serviceOverview.workStateQuery.d1': '清扫状态，请求成功时存在。s-清扫中，p-暂停中，h-空闲中，goposition-正在前往指定位置，gopositionpause-在指定点停止，findpet-寻找宠物，findpetpause-寻找宠物暂停，cruise-巡航中，cruisepause-巡航暂停，buildmap-创建地图，buildmappause-建图暂停',
  'pages.serviceOverview.workStateQuery.d2': '充电状态，请求成功时存在。g-正在回充，gp-回充暂停，i-空闲，sc-底座充电，wc-线充，charging-充电中（包括SC和WC）',
  'pages.serviceOverview.workStateQuery.d3': '基站状态，i-空闲，wash-正在清洗拖布，dry-正在烘干，drypause-烘干暂停，dust-集尘中，dustpause-集尘暂停，clean-基站清洁，cleanpause-基站清洁暂停，wash-清洗拖布，washpause-清洗拖布暂停',
  'pages.preparationForUse': '使用准备',
  'pages.preparationForUse.p1': '1. 登录科沃斯账号',
  'pages.preparationForUse.p2': '登录说明：输入手机号以及验证码，登录您的科沃斯账号。',
  'pages.preparationForUse.p3': '2. 获取服务密钥（AK）',
  'pages.preparationForUse.p4': '获取说明：登录科沃斯账号后，选择合适的有效期，复制并妥善保管您的服务密钥AK。',
  'pages.preparationForUse.p5': '去登录',
  'pages.preparationForUse.p6': '去获取',
  'pages.updateLog': '更新日志',
  'pages.updateLog.p1': '版本',
  'pages.updateLog.p2': '功能说明',
  'pages.updateLog.p3': '更新日期',
  'pages.updateLog.p4': 'Ecovacs MCP Server正式上线',
  'pages.contactUs': '联系我们',
  'pages.contactUs.email': '联系邮箱',
  'pages.contactUs.qrCode': '交流群二维码',

  'pages.hub.title': 'Ecovacs Hub',
  'pages.hub.mcpServer': 'MCP Server',
  'pages.hub.skillHub': 'Skills',
  'pages.hub.opensource': '开源',
  'pages.opensource.addProject': '+ 添加项目',

  'pages.skill.category.deebot': '地宝',
  'pages.skill.category.goat': '毛团儿',
  'pages.skill.category.hsr': 'HSR',
  'pages.skill.category.winbot': '窗宝',
  'pages.skill.category.mower': '割草机',
  'pages.skill.category.other': '其他',

  'pages.skill.build.name': '技能名称',
  'pages.skill.build.nameRequired': '请输入技能名称',
  'pages.skill.build.version': '版本号',
  'pages.skill.build.versionRequired': '请输入版本号',
  'pages.skill.build.versionFormat': '版本号格式为 x.x.x，如 1.0.0',
  'pages.skill.build.description': '技能描述',
  'pages.skill.build.descriptionRequired': '请输入技能描述',
  'pages.skill.build.type': '技能类型',
  'pages.skill.build.typeRequired': '请选择技能类型',
  'pages.skill.build.enabled': '是否启用',
  'pages.skill.build.public': '是否公开',
  'pages.skill.build.zip': '压缩包',
  'pages.skill.build.zipHint': '点击上传或拖拽文件到此处',
  'pages.skill.build.zipExtra': '支持 .tar.gz、.zip 和 .skill 格式',
  'pages.skill.build.zipRequired': '请上传压缩包',
  'pages.skill.build.submit': '提交',
  'pages.skill.build.success': '技能创建成功',
  'pages.skill.build.submitFailed': '提交失败',
  'pages.skill.build.submitting': '提交中…',
  'pages.skill.build.pageTitle': '上传技能',
  'pages.skill.build.versionPlaceholder': '1.0.0',
  'pages.skill.build.parsing': '正在解析技能信息...',
  'pages.skill.build.autofillSuccess': '已从技能文件中自动提取并填充表单',
  'pages.skill.build.autofillFailed': '文件已选择，但未能自动解析技能名称/描述',
  'pages.skill.build.preview': '预览',
  'pages.skill.build.previewEmpty': '上传 .skill 或 .zip 后，这里会展示 SKILL.md 的详细内容',
  'pages.skill.build.notAllowed': '无权限上传技能',

  'pages.skill.plaza.uploadSkill': '上传技能',
  'pages.skill.plaza.filterAll': '全部',
  'pages.skill.plaza.clawhubLink': '龙虾官方开源 Skill 平台（ClawHub）',
  'pages.skill.plaza.loadError': '加载技能列表失败',
  'pages.skill.plaza.retry': '重试',
  'pages.skill.plaza.noDesc': '暂无简介',
  'pages.skill.plaza.version': '版本',
  'pages.skill.plaza.updated': '更新',
  'pages.skill.plaza.download': '下载',
  'pages.skill.plaza.delete': '删除',
  'pages.skill.plaza.noFile': '无附件',
  'pages.skill.plaza.downloadOk': '已开始下载',
  'pages.skill.plaza.downloadFail': '下载失败',
  'pages.skill.plaza.deleteConfirmTitle': '删除技能',
  'pages.skill.plaza.deleteConfirmDesc': '确定删除「{name}」？此操作不可恢复。',
  'pages.skill.plaza.deleteOk': '已删除',
  'pages.skill.plaza.deleteFail': '删除失败',
  'pages.skill.plaza.deleteNotAllowed': '无权限删除技能',
  'pages.skill.plaza.empty': '该分类下暂无技能',
  'pages.skill.plaza.category': '分类',
  'pages.skill.plaza.tagEnabled': '已启用',
  'pages.skill.plaza.tagDisabled': '未启用',
  'pages.skill.plaza.tagPublic': '公开',
  'pages.skill.plaza.tagPrivate': '非公开',
  'pages.skill.plaza.totalItems': '个技能',
  'pages.skill.plaza.noMore': '没有更多了',
  'pages.skill.detail.title': '技能详情',
  'pages.skill.detail.back': '返回技能广场',
  'pages.skill.detail.loadError': '加载技能详情失败',
  'pages.skill.detail.notFound': '未找到该技能',
  'pages.skill.detail.name': '技能名称',
  'pages.skill.detail.description': '技能描述',
  'pages.skill.detail.fileTree': '文件目录',
  'pages.skill.detail.fileReadError': '读取技能文件失败',
  'pages.skill.detail.skillMdMissing': '未找到 SKILL.md',
  'pages.skill.detail.downloadSkill': '下载技能',
  'pages.skill.detail.versionHistory': '版本历史',
  'pages.skill.detail.currentVersion': '当前版本',
  'pages.skill.detail.currentVersionLabel': '当前版本',
  'pages.skill.detail.downloadVersion': '下载此版本',
  'pages.skill.detail.noFile': '无文件',
  'pages.skill.detail.noVersions': '暂无版本历史',
  'pages.skill.plaza.mock1.name': '儿童房玩具归位',
  'pages.skill.plaza.mock1.desc': '识别散落玩具并分类放入收纳盒，适合日常整理。',
  'pages.skill.plaza.mock2.name': '书桌杂物清理',
  'pages.skill.plaza.mock2.desc': '整理笔、书本与杂物，保持桌面可用工作区。',
  'pages.skill.plaza.mock3.name': '玄关鞋子摆放',
  'pages.skill.plaza.mock3.desc': '将鞋子对齐摆放并提示未穿袜子配对。',
  'pages.skill.plaza.mock4.name': '脏衣篮分拣提示',
  'pages.skill.plaza.mock4.desc': '区分深浅色与材质，给出洗衣程序建议。',
  'pages.skill.plaza.mock5.name': '自定义场景',
  'pages.skill.plaza.mock5.desc': '可扩展的其他家庭协作技能模板。',
};
